export default __webpack_public_path__ + "static/Corteca-c0382828372c3dc3454e7e0cc42e3296.gif";